import { Component } from 'vue-property-decorator';
import Vue from 'vue'

@Component
export class Device extends Vue {

	public isMobile: boolean = false;

	get isDesktop(): boolean {
		return !this.isMobile;
	}

	public created(): void {
		// Create the query list.
		const mediaQueryList: MediaQueryList = window.matchMedia('(min-width: 577px)');
		this.isMobile = !mediaQueryList.matches;
		mediaQueryList.addListener(event => {
			this.isMobile = !event.matches;
		});
	}
}

